import { userSessionStore } from "~/domain/user-session"

export function patchFetch() {
	// проксирование fetch
	globalThis.fetch = new Proxy(fetch, {
		async apply(
			target: typeof fetch,
			_thisArg: any,
			argArray: [input: RequestInfo | URL, init?: RequestInit]
		) {
			const input = argArray[0]
			const init = argArray[1] ?? {}

			const url = input instanceof Request ? input.url : input.toString()

			if (!url.includes(".kemsu.ru") || !url.startsWith("https://api")) {
				return await target(...argArray)
			}

			const options = {
				...init,
				credentials: url.includes(".kemsu.ru")
					? "include"
					: init.credentials
			}

			const request = new Request(input)

			const isAuthApi = request.url && (
				request.url.includes("refresh-token")
				|| request.url.includes("clean-tokens")
				|| request.url.includes("auth")
			)

			if (!isAuthApi) {
				userSessionStore.updateActivityDate()
				await userSessionStore.waitForRefreshToken()
			}

			const response = await target(request, options)

			// jwt expired
			if (response.status === 401 && !isAuthApi) {

				if (!(await userSessionStore.refreshToken())) {
					await userSessionStore.logout()
				}

				return await target(new Request(input), options)
			}

			return response
		}
	})
}